define('lib/model/BaseModel',['require','backbone','lib/validator/Validator'],function (require) {

	var Backbone = require('backbone');
	var Validator = require('lib/validator/Validator');

	/**
	 * BaseModel with url rewriter
	 *
	 * @class BaseModel
	 */
	return Backbone.Model.extend({

		baseUrl: '/v2',
		validators: {},

		/**
		 * Inits instance
		 * @todo check if baseUrl prepended twice if model is part of collection,
		 * and no urlRoot is given
		 */
		initialize: function () {
            if (this.url && _.isString(this.url)) {
                this.url = this.baseUrl + _.result(this, 'url');
            }
            if (this.urlRoot && _.isString(this.urlRoot)) {
                this.urlRoot = this.baseUrl + _.result(this, 'urlRoot');
            }

            this.listenTo(this, 'error', this.onError);

			Backbone.Model.prototype.initialize.call(this);
		},

		/**
		 * Perform validators before save
		 * Returns errors object or nothing if no errors.
		 * On errors model triggers invalid event, on this event we rerender view
		 *
		 * @return Object|null
		 */
		validate: function () {
			var errors = {};
			var allValidators = _.extend({}, this.validators, this.getValidators());

			_.each(allValidators, function (validators, field) {
				if (validators.length) {
					var validator = new Validator({
						validators: validators
					});
					if (!validator.isValid(this.get(field))) {
						errors[field] = validator.getErrors();
					}
				}
			}, this);

			_.each(this.attributes, function (attrVal, attrKey) {
				if (attrVal instanceof Backbone.Model) {
                    if (!attrVal.isValid()) {
						errors[attrKey] = attrVal.validationError;
					}
				}
                if (attrVal instanceof Backbone.Collection) {
                    attrVal.each(function (childModel, childModelKey) {
                        if (!childModel.isValid()) {
                        	if (!errors[attrKey]) {
                                errors[attrKey] = {};
							}
                            errors[attrKey][childModelKey] = childModel.validationError;
                        }
					});
                }
			}, this);

			if (!_.isEmpty(errors)) {
				return errors;
			}
		},

        /**
		 * Return validators object, like validators
		 * You can return validators here, based on attributes values
		 *
		 * @return {*}
         */
        getValidators: function () {
		},

		addValidationRules: function (rules) {
			var _this = this;
			if(!_.isObject(rules)){
				throw new Error('Validation rules must be an object');
			}
			_.each(rules, function (rule, field) {
				if (!_.isArray(rule)) {
					rule = [rule];
				}
				if (!_this.validators[field]) {
					_this.validators[field] = [];
				}
				_this.validators[field] = _this.validators[field].concat(rule);
			});
		},

		/**
		 * Trigger invalid event on save error
		 *
		 * @param model
		 * @param xhr
		 */
		onError: function (model, xhr) {
			// console.log(model);
			var res = {};
			if (xhr.responseJSON) {
				res = xhr.responseJSON;
			}

            if (res.errors) {
                this.setErrors(res.errors);
            }
		},

        setErrors: function (errors) {
            this.validationError = {};
            _.each(errors, function (item) {
                if (item.error) {
                    this.validationError[item.field] = item.error;
                }
                if (item.child_errors) {
                    var childModel = this.get(item.field);
                    if (childModel && _.isObject(childModel) && childModel.setErrors) {
                        childModel.setErrors(item.child_errors);
                    }
                }
            }, this);

            this.trigger('invalid');
        },

		syncWithPromise: function (method, options) {
			var _this = this;
			options = options || {};

			return new Promise(function (resolve, reject) {
				options.success = function (resp) {
					resolve(resp);

					if (options.parse) {
						_this.set(_this.parse(resp, options), options)
					}
					_this.trigger('sync', _this, resp, options);
				};
				options.error = function (resp) {
					reject(resp.responseJSON);

					_this.trigger('error', _this, resp, options);
				};

				_this.sync(method, _this, options);
			});
		}

	});

});

